<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('uomCategory.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('uomCategory.pageTitle'),
            ref: '/admin/uom-categories'
          },
          {
            text: $t('edit'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-md-3 col-sm-12">
            <div class="form-group">
              <label>{{ $t('uomCategory.nameKh') }}</label>
              <input
                type="text"
                v-model="model.uom_cat_name_kh"
                class="form-control kh-font"
                :class="{ 'is-invalid': errors.has('uom_cat_name_kh') }"
              />
              <div
                class="invalid-feedback"
                v-if="errors.has('uom_cat_name_kh')"
              >
                {{ errors.first('uom_cat_name_kh') }}
              </div>
            </div>
          </div>
          <div class="col-md-3 col-sm-12">
            <div class="form-group">
              <label class="required">{{ $t('uomCategory.nameEn') }}</label>
              <input
                type="text"
                v-model="model.uom_cat_name_en"
                class="form-control"
                :class="{ 'is-invalid': errors.has('uom_cat_name_en') }"
              />
              <div
                class="invalid-feedback"
                v-if="errors.has('uom_cat_name_en')"
              >
                {{ errors.first('uom_cat_name_en') }}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 col-sm-12">
            <table class="table ui-table">
              <thead>
                <tr>
                  <th>{{ $t('uomCategory.nameKh') }}</th>
                  <th>{{ $t('uomCategory.nameEn') }}</th>
                  <th style="width:15%">{{ $t('uomCategory.stockOutQty') }}</th>
                  <th style="width:7%">{{ $t('uomCategory.default') }}</th>
                  <th style="width:3%">
                    <a
                      href="#"
                      class="text-primary"
                      @click.prevent="addNewItem"
                    >
                      <i class="fas fa-plus"></i>
                    </a>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in model.uom_list.filter(a => a.is_deleted == false)" :key="index">
                  <td>
                    <input
                      type="text"
                      v-model.trim="item.uom_name_kh"
                      class="form-control kh-font only-border-bottom"
                      :class="{
                        'is-invalid': errors.has(
                          'uom_list.' + index + '.uom_name_kh'
                        )
                      }"
                    />
                    <div
                      class="invalid-feedback"
                      v-if="errors.has('uom_list.' + index + '.uom_name_kh')"
                    >
                      {{ errors.first('uom_list.' + index + '.uom_name_kh') }}
                    </div>
                  </td>
                  <td>
                    <input
                      type="text"
                      v-model.trim="item.uom_name_en"
                      class="form-control only-border-bottom"
                      :class="{
                        'is-invalid': errors.has(
                          'uom_list.' + index + '.uom_name_en'
                        )
                      }"
                    />
                    <div
                      class="invalid-feedback"
                      v-if="errors.has('uom_list.' + index + '.uom_name_en')"
                    >
                      {{ errors.first('uom_list.' + index + '.uom_name_en') }}
                    </div>
                  </td>
                  <td>
                    <input
                      type="number"
                      v-model.number="item.stockout_quantity"
                      class="form-control only-border-bottom"
                      :class="{
                        'is-invalid': errors.has(
                          'uom_list.' + index + '.stockout_quantity'
                        )
                      }"
                      placeholder="Enter quantity"
                    />
                    <div
                      class="invalid-feedback"
                      v-if="
                        errors.has('uom_list.' + index + '.stockout_quantity')
                      "
                    >
                      {{
                        errors.first('uom_list.' + index + '.stockout_quantity')
                      }}
                    </div>
                  </td>
                  <td>
                    <div class="radio radio-css ml-4">
                      <input
                        type="radio"
                        name="is_default"
                        :value="true"
                        :id="index"
                        v-model="item.is_default"
                        @click="setDefault(item)"
                      />
                      <label :for="index"></label>
                    </div>
                  </td>
                  <td>
                    <a
                      href="#"
                      class="text-danger"
                      @click.prevent="removeItem(item)"
                    >
                      <i class="fa fa-trash"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-12 ts-flex ts-justify-end ts-space-x-3">
            <ts-button
              class="btn-default"
              @click="$router.push({ name: 'uom-category' })"
              >{{ $t('cancel') }}</ts-button
            >
            <ts-button
              color="primary"
              v-if="model.uom_list.length > 0"
              :waiting="waiting"
              @click.prevent="update"
              >{{ $t('update') }}</ts-button
            >
          </div>
        </div>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>
<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'

export default {
  name: 'uomCategoryEdit',
  data() {
    return {
      model: {
        uom_cat_id: '',
        uom_cat_name_kh: '',
        uom_cat_name_en: '',
        uom_list: []
      },
      newItem: {
        uom_id: 0,
        uom_name_kh: '',
        uom_name_en: '',
        stockout_quantity: 1,
        is_default: false,
        is_deleted: false
      },
      errors: new Errors(),
      waiting: false
    }
  },
  created() {
    this.setEditData()
  },
  computed: {
    ...mapState('product/uomCategory', ['edit_data'])
  },
  methods: {
    addNewItem() {
      this.model.uom_list.push(_.clone(this.newItem))
    },
    removeItem(item) {
        if(item.uom_id){
            item.is_deleted = true
        }
        else
        {
            this.model.uom_list.splice(this.model.uom_list.indexOf(item), 1)
        }
    },
    update() {
      this.checkHasDefault()
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('product/uomCategory/update',{
            id: this.model.uom_cat_id,
            data: this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'uom-category' })
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
          this.waiting = false
        })
    },
    setDefault(item) {
      this.model.uom_list
        .filter(el => el.is_default == true)
        .forEach(el => (el.is_default = false))
    },
    setEditData() {
      this.model = {
        uom_cat_id: this.edit_data.uom_cat_id,
        uom_cat_name_kh: this.edit_data.uom_cat_name_kh,
        uom_cat_name_en: this.edit_data.uom_cat_name_en,
        uom_list: _.clone(this.edit_data.unit_of_measures)
      }
    },
    checkHasDefault() {
      let result = this.model.uom_list.filter(el => el.is_default == true)
      if (!result.length > 0) {
        this.$toasted.info('Please set deafult on UOM')
        throw 'something went wrong'
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('product/uomCategory/RESET_STATE')
    }
    next()
  }
}
</script>

<style lang="css" scoped>
table td {
	vertical-align : middle;
}
.only-border-bottom {
	border-top: none;
	border-left: none;
	border-right: none;
	outline: none;
}
.table > tbody > tr > td{
	padding-top: 5px !important;
	padding-bottom: 5px !important;
	border: none !important
}
</style>
